import { createContext, useContext, type ReactNode } from 'react';
import { httpInterviewerService } from '../services/interviewer';
import type { InterviewerService } from '../services/interviewer.types';

/**
 * Which service the interviewer screens talk to. The real one by default;
 * tests and the development preview put a fake in its place.
 */
const ServiceContext = createContext<InterviewerService>(
  httpInterviewerService,
);

export const InterviewerServiceProvider = ({
  service,
  children,
}: {
  service: InterviewerService;
  children: ReactNode;
}) => (
  <ServiceContext.Provider value={service}>{children}</ServiceContext.Provider>
);

export const useInterviewerService = () => useContext(ServiceContext);
